//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BffClientBase {
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface IOnderwijsClient {
    /**
     * @return OK
     */
    geefHistoriekInschrijvingen_GeefHistoriekInschrijving(request: GeefHistoriekInschrijvingRequest): Promise<GeefHistoriekInschrijvingResponse>;
    buildInfo_Index(): Promise<FileResponse>;
}

export class OnderwijsClient extends BffClientBase implements IOnderwijsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:48886";

    }

    /**
     * @return OK
     */
    geefHistoriekInschrijvingen_GeefHistoriekInschrijving(request: GeefHistoriekInschrijvingRequest, cancelToken?: CancelToken | undefined): Promise<GeefHistoriekInschrijvingResponse> {
        let url_ = this.baseUrl + "/api/v1/geefhistoriekinschrijvingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefHistoriekInschrijvingen_GeefHistoriekInschrijving(_response));
        });
    }

    protected processGeefHistoriekInschrijvingen_GeefHistoriekInschrijving(response: AxiosResponse): Promise<GeefHistoriekInschrijvingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeefHistoriekInschrijvingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeefHistoriekInschrijvingResponse>(null as any);
    }

    buildInfo_Index( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/buildinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBuildInfo_Index(_response));
        });
    }

    protected processBuildInfo_Index(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface GeefHistoriekInschrijvingResponse {
    inschrijvingen?: InschrijvingDto[];
    waarschuwingen?: MagdaError[];
}

export interface InschrijvingDto {
    bron?: string;
    referte?: string;
    instelling?: InstellingDto;
    onderwijsLocatie?: OnderwijsLocatieDto;
    leerplichtOnderwijs?: LeerplichtOnderwijsDto;
    hogerOnderwijs?: HogerOnderwijsDto;
    volwassenenOnderwijs?: VolwassenenOnderwijsDto;
    internaat?: InternaatDto;
}

export interface InstellingDto {
    instellingsnummer?: string;
    naam?: string;
    instantie?: string;
    adres?: AdresDto;
    contactgegevens?: ContactgegevensDto;
    leerplichtOnderwijs?: LeerplichtOnderwijsDto;
    hogerOnderwijs?: HogerOnderwijsDto;
}

export interface AdresDto {
    straatnaam?: string;
    huisnummer?: string;
    busnummer?: string;
    nisCode?: string;
    postcode?: string;
    gemeente?: string;
    land?: string;
    landCode?: string;
}

export interface ContactgegevensDto {
    website?: string;
    email?: string;
    telefoonNummer?: string;
}

export interface LeerplichtOnderwijsDto {
    soortProgramma?: CodeOmschrijvingDto;
    datumInschrijving?: Date;
    datumEersteLes?: Date;
    schooljaar?: string;
    inschrijvingAdministratieveGroep?: InschrijvingAdministratieveGroepDto;
}

export interface CodeOmschrijvingDto {
    code?: string;
    omschrijving?: string;
}

export interface InschrijvingAdministratieveGroepDto {
    referte?: string;
    begin?: Date;
    einde?: Date | undefined;
    nummer?: string;
    naam?: string;
    niveau?: CodeOmschrijvingDto;
    soortOnderwijs?: CodeOmschrijvingDto;
    leerweg?: CodeOmschrijvingDto;
    typeBuitengewoonOnderwijs?: CodeOmschrijvingDto;
    aanleidingUitschrijving?: CodeOmschrijvingDto;
    situatieUitschrijving?: CodeOmschrijvingDto;
    andertaligeNieuwkomer?: boolean;
    gewezenAnderstaligeNieuwkomer?: boolean;
}

export interface HogerOnderwijsDto {
    academiejaar?: string;
    status?: CodeOmschrijvingDto;
    datumInschrijving?: Date;
    datumUitschrijving?: Date | undefined;
    soortContract?: CodeOmschrijvingDto;
    opleiding?: OpleidingHogerOnderwijsDto;
    studiepunten?: StudiepuntenDto;
    studieOmvang?: string;
    studieBewijsHaalbaar?: boolean;
    toereikendeStudieOmvang?: boolean;
    studieBewijzen?: StudieBewijsDto[];
    volgendeOpleiding?: OpleidingHogerOnderwijsDto;
    vorigeOpleiding?: OpleidingHogerOnderwijsDto;
}

export interface OpleidingHogerOnderwijsDto {
    code?: string;
    naam?: string;
    prefixGraad?: string;
    graad?: string;
    specificatieGraad?: string;
    prefixKwalificatie?: string;
    kwalificatie?: string;
    soort?: CodeOmschrijvingDto;
}

export interface StudiepuntenDto {
    opgenomen?: string;
    verworven?: string;
    gedelibereerd?: string;
    geenResultaat?: string;
    nietDeelgenomen?: string;
    nietGeslaagd?: string;
    nietVerworven?: string;
    vrijgesteld?: string;
    uitgeschreven?: string;
}

export interface StudieBewijsDto {
    referte?: string;
    ledReferte?: string;
}

export interface OnderwijsLocatieDto {
    nummer?: string;
    omschrijving?: string;
    adres?: AdresDto;
    contactgegevens?: ContactgegevensDto;
}

export interface VolwassenenOnderwijsDto {
    status?: CodeOmschrijvingDto;
    datumInschrijving?: Date;
    datumUitschrijving?: Date | undefined;
    opleiding?: OpleidingVolwassenenOnderwijsDto;
    module?: ModuleVolwassenenOnderwijsDto;
    resultaat?: CodeOmschrijvingDto;
    studieBewijzen?: StudieBewijsDto[];
}

export interface OpleidingVolwassenenOnderwijsDto {
    code?: string;
    naam?: string;
    omschrijving?: string;
    diplomagericht?: boolean;
    opleidingsvariant?: CodeOmschrijvingDto;
    traject?: CodeOmschrijvingDto;
}

export interface ModuleVolwassenenOnderwijsDto {
    code?: string;
    naam?: string;
    omschrijving?: string;
    moduleVariant?: CodeOmschrijvingDto;
    traject?: CodeOmschrijvingDto;
    studiepunten?: number | undefined;
}

export interface InternaatDto {
    schooljaar?: string;
    begin?: Date;
    einde?: Date | undefined;
}

export interface MagdaError {
    message: string | undefined;
    description?: string | undefined;
    externalCode?: string | undefined;
    type?: MagdaErrorType;
}

export enum MagdaErrorType {
    Error = "Error",
    Warning = "Warning",
    Information = "Information",
}

export interface ErrorMessage {
    type?: string | undefined;
    title: string;
    status?: number;
    detail: string;
    instance?: string | undefined;
}

export interface GeefHistoriekInschrijvingRequest {
    insz?: string;
    referte?: string;
    from?: Date;
    until?: Date;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}